<mat-form-field appearance="outline" class="w-full">
  <mat-label>Tipo de anexo</mat-label>

  <mat-select [(value)]="value" (valueChange)="onInternalChange($event)">
    <mat-option *ngFor="let tipo of tipos" [value]="tipo.value">
      {{ tipo.label }}
    </mat-option>
  </mat-select>

</mat-form-field>
